import "./style.css";

export const PopularServices = ({ onServiceClick }) => {
  const services = [
    {
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
          <rect
            x="4"
            y="4"
            width="16"
            height="18"
            rx="1"
            fill="#17a2b8"
            stroke="#138496"
            strokeWidth="1"
          />
          <rect
            x="6.5"
            y="6.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="10.5"
            y="6.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="14.5"
            y="6.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="6.5"
            y="10"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="10.5"
            y="10"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="14.5"
            y="10"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="6.5"
            y="13.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="10.5"
            y="13.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect
            x="14.5"
            y="13.5"
            width="3"
            height="2.5"
            fill="white"
            opacity="0.9"
          />
          <rect x="9.5" y="17" width="5" height="5" fill="#2c3e50" />
          <line
            x1="12"
            y1="4"
            x2="12"
            y2="1"
            stroke="#e74c3c"
            strokeWidth="1.5"
          />
          <path d="M12 1L16 3L12 4.5V1Z" fill="#e74c3c" />
        </svg>
      ),
      title: "Company Registration",
      subtitle:
        "Register your company hassle-free with full legal assurance in a matter of days.",
      plan: "Plan starting from @2999",
      color: "#17a2b8",
    },
    {
      icon: "🏛️",
      title: "GST Registration & Compliance",
      subtitle:
        "Complete GST registration, filing, and advisory under one roof.",
      plan: "Plan starting from @999",
      color: "#17a2b8",
    },
    {
      icon: "📁",
      title: "Tax Filing & ITR",
      subtitle:
        "Accurate, timely, and compliant income tax filing for individuals and businesses.",
      plan: "Plan starting from @699",
      color: "#17a2b8",
    },
    {
      icon: "⚖️",
      title: "Legal Drafts & ROC",
      subtitle:
        "From resolutions to annual filings—complete ROC and legal documentation support.",
      plan: "Plan starting from @799",
      color: "#ffc107",
    },
  ];

  return (
    <section className="popular-services">
      <div className="popular-services-container">
        <h2 className="section-title">Popular Services</h2>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card">
              <div
                key={index}
                className="service-container"
                onClick={() => onServiceClick && onServiceClick(service.title)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="service-icon"
                  style={{ backgroundColor: `${service.color}20` }}
                >
                  {typeof service.icon === "string" ? (
                    <span style={{ color: service.color, fontSize: "2rem" }}>
                      {service.icon}
                    </span>
                  ) : (
                    service.icon
                  )}
                </div>
                <div className="service-info">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-subtitle">{service.subtitle}</p>
                </div>
              </div>
              <span className="service-plan"> {service.plan}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
